var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"text"},[_vm._v("\n        이전 미션을 완료해주세요.\n    ")]),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("\n        닫기\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494b76d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/runner/Modal2.vue
// module id = null
// module chunks = 